import React from "react";

function ArrowDown() {
	return (
		<svg
			className="arrowIcon"
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="25"
			fill="none"
			viewBox="0 0 24 25"
		>
			<path
				fill="#10324C"
				fillRule="evenodd"
				d="M5.293 8.793a1 1 0 011.414 0L12 14.086l5.293-5.293a1 1 0 111.414 1.414l-6 6a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414z"
				clipRule="evenodd"
			/>
		</svg>
	);
}

export default React.memo(ArrowDown);
